import { render, staticRenderFns } from "./privateWaybill.vue?vue&type=template&id=68dc6238&"
import script from "./privateWaybill.vue?vue&type=script&lang=js&"
export * from "./privateWaybill.vue?vue&type=script&lang=js&"
import style0 from "./privateWaybill.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "privateWaybill.vue"
export default component.exports